export const predefinedAchievements = [
  {
    name: 'First Scribble',
    description: 'Write 50 words',
    target: 50,
    category: 'wordCount',
  },
  {
    name: 'Budding Writer',
    description: 'Write 100 words',
    target: 100,
    category: 'wordCount',
  },
  {
    name: 'Getting in the Groove',
    description: 'Write 200 words',
    target: 200,
    category: 'wordCount',
  },
  {
    name: 'Ink Slinger',
    description: 'Write 500 words',
    target: 500,
    category: 'wordCount',
  },
  {
    name: 'Page Turner',
    description: 'Write 1000 words',
    target: 1000,
    category: 'wordCount',
  },
  {
    name: 'Word Weaver',
    description: 'Write 2000 words',
    target: 2000,
    category: 'wordCount',
  },
  {
    name: 'Paragraph Pro',
    description: 'Write 3000 words',
    target: 3000,
    category: 'wordCount',
  },
  {
    name: 'Storyteller',
    description: 'Write 5000 words',
    target: 5000,
    category: 'wordCount',
  },
  {
    name: 'Epic Author',
    description: 'Write 10000 words',
    target: 10000,
    category: 'wordCount',
  },
  {
    name: 'Legendary Scribe',
    description: 'Write 20000 words',
    target: 20000,
    category: 'wordCount',
  },
  {
    name: 'First Entry',
    description: 'Create your first entry',
    target: 1,
    category: 'entryCount',
  },
  {
    name: 'Diary Dabbler',
    description: 'Create 3 entries',
    target: 3,
    category: 'entryCount',
  },
  {
    name: 'Journal Juggler',
    description: 'Create 5 entries',
    target: 5,
    category: 'entryCount',
  },
  {
    name: 'Notebook Navigator',
    description: 'Create 10 entries',
    target: 10,
    category: 'entryCount',
  },
  {
    name: 'Memoir Maker',
    description: 'Create 20 entries',
    target: 20,
    category: 'entryCount',
  },
  {
    name: 'Logbook Luminary',
    description: 'Create 30 entries',
    target: 30,
    category: 'entryCount',
  },
  {
    name: 'Chronicle Creator',
    description: 'Create 40 entries',
    target: 40,
    category: 'entryCount',
  },
  {
    name: 'Script Specialist',
    description: 'Create 50 entries',
    target: 50,
    category: 'entryCount',
  },
  {
    name: 'Entry Expert',
    description: 'Create 75 entries',
    target: 75,
    category: 'entryCount',
  },
  {
    name: 'Writing Wizard',
    description: 'Create 100 entries',
    target: 100,
    category: 'entryCount',
  }, 
  {
    name: 'File Organizer',
    description: 'Create 1 collection',
    target: 1,
    category: 'folderCount',
  },
  {
      name: 'Collection Curator',
      description: 'Create 3 collections',
      target: 3,
      category: 'folderCount',
  },
  {
      name: 'Archive Architect',
      description: 'Create 5 collections',
      target: 5,
      category: 'folderCount',
  },
  {
      name: 'Compilation Maestro',
      description: 'Create 10 collections',
      target: 10,
      category: 'folderCount',
  },
  {
      name: 'Vault Virtuoso',
      description: 'Create 15 collections',
      target: 15,
      category: 'folderCount',
  },
  {
      name: 'Organizer Master',
      description: 'Save 5 entries in a folder',
      target: 5,
      category: 'entriesInFolder',
  },
  {
      name: 'Collection Enthusiast',
      description: 'Save 10 entries in a folder',
      target: 10,
      category: 'entriesInFolder',
  },
  {
      name: 'Content Specialist',
      description: 'Save 15 entries in a folder',
      target: 15,
      category: 'entriesInFolder',
  },
  {
      name: 'Archive Collector',
      description: 'Save 20 entries in a folder',
      target: 20,
      category: 'entriesInFolder',
  },
  {
      name: 'Archive Master',
      description: 'Save 25 entries in a folder',
      target: 25,
      category: 'entriesInFolder',
  },
  {
    name: 'Tagging Novice',
    description: 'Use a tag for the first time',
    target: 1,
    category: 'tagUsage',
  },
  {
    name: 'Tag Enthusiast',
    description: 'Use tags in 5 different entries',
    target: 5,
    category: 'tagUsage',
  },
  {
    name: 'Tagging Expert',
    description: 'Use tags in 10 different entries',
    target: 10,
    category: 'tagUsage',
  },
  {
    name: 'Tagging Master',
    description: 'Use tags in 20 different entries',
    target: 20,
    category: 'tagUsage',
  },
  {
    name: 'Tagging Guru',
    description: 'Use tags in 50 different entries',
    target: 50,
    category: 'tagUsage',
  },
  {
    name: 'Tagging Legend',
    description: 'Use tags in 100 different entries',
    target: 100,
    category: 'tagUsage',
  },
  {
    name: 'Tag Focused',
    description: 'Use the same tag in 5 different entries',
    target: 5,
    category: 'specificTagUsage',
  },
  {
    name: 'Tag Specialist',
    description: 'Use the same tag in 10 different entries',
    target: 10,
    category: 'specificTagUsage',
  },
  {
    name: 'Tag Devotee',
    description: 'Use the same tag in 20 different entries',
    target: 20,
    category: 'specificTagUsage',
  },
  {
    name: 'Tag Expert',
    description: 'Use the same tag in 50 different entries',
    target: 50,
    category: 'specificTagUsage',
  },
  {
    name: 'Tag Master',
    description: 'Use the same tag in 100 different entries',
    target: 100,
    category: 'specificTagUsage',
  },
  {
    name: 'Tag Legend',
    description: 'Use the same tag in 200 different entries',
    target: 200,
    category: 'specificTagUsage',
  },
  {
    name: 'Quick Scribbler',
    description: 'Spend 5 minutes writing',
    target: 5, 
    category: 'timeSpentWriting',
  },
  {
    name: 'Casual Writer',
    description: 'Spend 30 minutes writing',
    target: 30, 
    category: 'timeSpentWriting',
  },
  {
    name: 'Dedicated Author',
    description: 'Spend 1 hour writing',
    target: 60, 
    category: 'timeSpentWriting',
  },
  {
    name: 'Story Weaver',
    description: 'Spend 2 hours writing',
    target: 2 * 60,
    category: 'timeSpentWriting',
  },
  {
    name: 'Marathon Scribe',
    description: 'Spend 5 hours writing',
    target: 5 * 60,
    category: 'timeSpentWriting',
  },
  {
    name: 'Writing Enthusiast',
    description: 'Spend 10 hours writing',
    target: 10 * 60, 
    category: 'timeSpentWriting',
  },
  {
    name: 'Prolific Penner',
    description: 'Spend 20 hours writing',
    target: 20 * 60, 
    category: 'timeSpentWriting',
  },
  {
    name: 'Epic Wordsmith',
    description: 'Spend 30 hours writing',
    target: 30 * 60, 
    category: 'timeSpentWriting',
  },
  {
    name: 'Legendary Writer',
    description: 'Spend 50 hours writing',
    target: 50 * 60,
    category: 'timeSpentWriting',
  },
  {
    name: 'Immortal Scribe',
    description: 'Spend 100 hours writing',
    target: 100 * 60,
    category: 'timeSpentWriting',
  },
  {
    name: 'Brain Teaser',
    description: 'Tackle your first writing challenge',
    target: 1,
    category: 'promptUsage',
  },
  {
    name: 'Idea Wrangler',
    description: 'Wrestle with 5 different challenges',
    target: 5,
    category: 'promptUsage',
  },
  {
    name: 'Concept Conqueror',
    description: 'Master 10 writing challenges',
    target: 10,
    category: 'promptUsage',
  },
  {
    name: 'Thought Tamer',
    description: 'Dominate 20 brainy tasks',
    target: 20,
    category: 'promptUsage',
  },
  {
    name: 'Creative Crusader',
    description: 'Overcome 50 mental quests',
    target: 50,
    category: 'promptUsage',
  },
  {
    name: 'Idea Whisperer',
    description: 'Complete 100 imaginative missions',
    target: 100,
    category: 'promptUsage',
  },
]